import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, TextField, RadioGroup, Radio, FormGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepTwo(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect(() => {
        if (props.datas.frequence) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                A quelle fréquence mettez-vous vos biens à disposition de la location à court et moyen terme ?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        defaultValue={props.datas.frequence}
                        name="radio-buttons-group">
                        <FormControlLabel
                            value="Quelques jours seulement"
                            control={<Radio name='frequence'
                                onChange={(e) => handleChange(e)} />}
                            label="Quelques jours seulement" />
                        <FormControlLabel
                            value="Moins de 120 jours par an"
                            control={
                                <Radio name='frequence'
                                    onChange={(e) => handleChange(e)} />}
                            label="Moins de 120 jours par an" />
                        <FormControlLabel
                            value="Toute l’année"
                            control={
                                <Radio name='frequence'
                                    onChange={(e) => handleChange(e)} />}
                            label="Toute l’année" />

                    </RadioGroup>
                </FormControl>
                <TextField
                    id="outlined-multiline-static"
                    label="Autres : Veuillez préciser"
                    name='frequence'
                    multiline
                    rows={3}
                    sx={{ width: '100%' }}
                    onChange={(e) => handleChange(e)}
                />
            </Typography>
            <ModalFooter buttons={buttons} />
        </>
    )
}